module.exports = __webpack_public_path__ + "media/categories/dyson-sphere-96-c5cb5ed3.png";